export const AnalysisTabId = 2;
export const ELIMINATION_CRITERIA_OTHER_INDEX = 4;
export const ELIMINATION_CRITERIA_OTHER_DISPLAY_ORDER = 5;

// This enum is associated with TabId
export enum TabSteps {
  leverageStudy = 0,
  studyInfo = 1,
  testedPartyInfo = 2,
  studyAccess = 3,
  review_submit = 4,
}

// This enum is associated with Study statusId  and mapped with lookup table values
export enum StudyStatus {
  InProgress = 7,
  UnderReview = 8,
  AwaitingApproval = 9,
  Approved = 10,
  Complete = 11,
  Archived = 12,
}

// This enum is associated with role table
export enum RoleEnum {
  Preparer = 1,
  Reviewer = 2,
  Approver = 3,
  Both = 4,
}

// This enum is associated with lookup table
export enum LookupType {
  CurrencyUnit = 1,
  StudyStatus = 6,
  FinancialResultsFormatting = 118,
  StudySettings = 121,
  EliminationCriteria = 163,
  NonBvdDatabaseType = 299,
  CompustatCompanyStatus = 302,
  NonBvdComparableType = 180,
}

// This enum is associated with lookup table for type='FinancialResultsFormatting'
export enum FinancialResultsFormattingLookupValues {
  EYQuartileRange = 119,
  StatisticalQuartileRange = 120,
}

// This enum is associated with lookup table for type='FinancialResultsFormatting'
export enum StudySettingsLookupValues {
  FullOverview = 122,
  TradeDescription = 123,
  Both = 124,
}

// This enum is associated with selected Keywords (Include Function, Include Product, Exclude)
export enum KeywordType {
  IncludeFunction = 126,
  IncludeProduct = 127,
  Exclude = 128,
}

// This enum is associated with the status of the Keyword Extraction Process
export enum StudySearchStrategyProcess {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Zombie = 3,
  Failed = 4,
}

export enum PipelineStatus {
  Pending = 0,
  Active = 1,
  Ended = 2,
  EndedWithError = 3,
}

export enum BooleanOperations {
  And = 'and',
  Or = 'or',
}

export enum StudyAnalysisSteps {
  SearchStrategy = 0,
  KeywordSearch = 1,
  BDReview = 2,
  InternetReview = 3,
  FinancialReview = 4,
  MasterMatrix = 5,
}

export enum ComparableStatus {
  Accepted = 131,
  Rejected = 132,
  Neutral = 161,
  All = 1,
}

export enum SectionType {
  BDReviewFinalResult = 160,
  BDReviewMatrix = 170,
  InternetReview = 176,
  FinancialReviewMatrix = 178,
  MasterMatrix = 217,
}

export enum BdReviewSteps {
  keywordExtraction = 0,
  bdMatrix = 1,
  eliminationMatrix = 2,
  finalResults = 3,
}

export enum EliminationMatrixColumnDefinition {
  bdMatrixId = 'bdMatrixId',
  bdMatrixSubsetId = 'bdMatrixSubsetId',
  bvDId = 'bvDId',
  comment = 'comment',
  companyName = 'companyName',
  companyShortName = 'companyShortName',
  companyWebSite = 'companyWebSite',
  comparableID = 'comparableID',
  comparableStatusId = 'comparableStatusId',
  countryName = 'countryName',
  fullOverviewEN = 'fullOverviewEN',
  rejectedReason = 'rejectedReason',
  isReviewed = 'isReviewed',
  reviewed = 'reviewed',
  tradeDescEN = 'tradeDescEN',
  tradeDescNL = 'tradeDescNL',
  tradeDescNLLang = 'tradeDescNLLang',
  status = 'status',
  comparableStatus = 'status',
  bdMatrixSubset = 'subset',
  subsetId = 'subsetId',
  isModified = 'isModified',
  tradeDescTranslated = 'tradeDescTranslated',
  // internet review extra column
  irComparableStatusId = 'irComparableStatusId',
  irStatus = 'irStatus',
  comparableAddress = 'comparableAddress',
  comparableCity = 'comparableCity',
  comparableState = 'comparableState',
  comparablePhone = 'comparablePhone',
  referenceId = 'referenceId',
  selectedWebsite = 'selectedWebsite',
  suggestedWebsite = 'suggestedWebsite',
  useSuggestedWebsite = 'useSuggestedWebsite',
  isGoodMatch = 'isGoodMatch',
  linkToOneSource = 'linkToOneSource',
  linkToSEC = 'linkToSEC',

  // master matrix extra column
  sourceId = 'sourceId',
  sourceReason = 'sourceReason',
  sourceName = 'sourceName',
  websiteSelected = 'websiteSelected',

  // Prediction engine columns
  functionPrediction = 'functionPrediction',
  functionConfidence = 'functionConfidence',
  fnPredictionWithConfidence = 'fnPredictionWithConfidence',
  isFunctionPredictionMarkedAsComparable = 'isFunctionPredictionMarkedAsComparable',
  productPrediction = 'productPrediction',
  productConfidence = 'productConfidence',
  prPredictionWithConfidence = 'prPredictionWithConfidence',
  isProductPredictionMarkedAsComparable = 'isProductPredictionMarkedAsComparable',
  isFunctionPredictionAvailable = 'isFunctionPredictionAvailable',
  isProductPredictionAvailable = 'isProductPredictionAvailable',
  aiClusterName = 'aiClusterName',
  aiRational = 'aiRational',
  aiConfidenceLevelName = 'aiConfidenceLevelName',
}

export enum PredictionEngineOptions {
  Comparable = 'Comparable',
  NotComparable = 'Not Comparable',
  NA = 'N/A',
}

export enum PredictionEngineUserOptions {
  Agree = 'Comparable',
  Disagree = 'Not Comparable',
}

export enum BasePLIVendorAccount {
  OperatingRevenue = 31,
  NetSales = 40,
}

export enum FYAlignmentMethod {
  March31 = 157,
  Previous7Month = 158,
}

export enum ReportTemplates {
  SearchStrategy = 0,
  KeywordScreening = 1,
  BDMatrix = 2,
  InternetReview = 3,
  FinancialAdjustments = 4,
  AcceptedCompanies = 5,
  AcceptedRejectedCompanies = 6,
  EliminationChart = 7,
  EngagementCodeReport = 8,
  FinancialAutoAdjustments = 9,
  DetailedPLISummary = 10,
  SearchWriteUp = 11,
  ContemporaryFinancialSummaryReport = 12,
  StudyByDate = 13,
}

export enum CompleteStatus {
  Name = 'Complete',
  DisplayText = 'Complete',
  LookupId = 11,
  DisplayOrder = 1610,
}

export enum InProgressStatus {
  Name = 'InProgress',
  DisplayText = 'InProgress',
  LookupId = 7,
  DisplayOrder = 1570,
}

export enum SubsetDialogMode {
  AddToExistingSubset = 'AddToExistingSubset',
  AddNewSubset = 'AddNewSubset',
  RemoveFromSubset = 'RemoveFromSubset',
}

export enum SourceEnum {
  KeywordScreening = 1,
  BusinessDescriptionReview = 2,
  InternetReview = 3,
  FinancialReview = 4,
  MasterMatrix = 5,
  Other = 6,
}

export enum RatioType {
  ROA = 4,
  BerryRatio = 7,
  GrossMargin = 8,
  OperatingMargin = 10,
  NetCostPlus = 9,
  GrossMarginAlternate = 11,
  ReturnOnInvestedCapital = 13,
  GrossCostPlus = 14,
  GrossCostPlusAlternative = 15,
  ReturnOnLongTermAssets = 16,
  ReturnOnCapitalEmployed = 17,
  ModifiedROA = 36,
}

// This enum is associated with lookup table for type='AveragingMethod'
export enum AveragingMethodId {
  SimpleAverage = 172,
  WeightedAverage = 173,
  Pooling = 174,
}

//This enum is associated with lookup table where parentid=163 (EliminationCriteria), values are mapped with displayorder
export enum EliminationCriteriaLookup {
  Significantly_different_functions = 1,
  Significantly_different_products_services = 2,
  Potential_intercompany_transactions = 3,
  Insufficient_information = 4,
  Other = 5,
  Financial_Review = 6,
}

export enum PredictionEngineTooltip {
  NotAvailable = 'Business Description is unavailable. Accordingly, no prediction from the AI/ML component can be provided',
}

export enum AdjustmentLookup {
  AdjustmentType = 326,
}
export enum AdjustmentInterestRateVariantLookup {
  AdjustmentInterestRateVariant = 355,
}
export enum CompustatRegion {
  NorthAmerica = 403,
  Americas = 404,
}

/**
 * @deprecated Please use DatabaseType instead
 */
export enum NonBvdDatabaseType {
  CompustatNA = 9,
  CompustatGlobal = 11,
  OneSource = 12,
}

export enum DatabaseType {
  AmadeusAll = 2,
  AmadeusVLLM = 3,
  Oriana = 4,
  Osiris = 5,
  CompustatNA = 9,
  CompustatGlobal = 11,
  OneSource = 12,
  TPCOrbisAPAC = 13,
  TPCOrbisEurope = 14,
  TPCOrbisListed = 15,
  TPCOrbisEuropeVLLM = 16,
  TPCOrbisALL = 17,
}

export enum NonBvdVendorName {
  OneSource = 'OneSource',
  Compustat = 'Compustat',
}

export enum RemoveNonBvdToNonBvdFilter {
  Location = 27,
  Status = 28,
  IndustryClassification = 62,
}

export enum RemoveBvdToNonBvdFilter {
  AccountTypes = 29,
  CategoryOfCompany = 26,
  BvdIndependenceIndicator = 115,
  CharacteristicsOfShareholder = 30,
  CharacteristicsOfSubsidiary = 101,
  LegalForm = 31,
  Status = 28,
  Location = 27,
  IndustryClassification = 62,
  ListedUnlisted = 382,
}

export enum RemoveNonBvdToBvdFilter {
  NumberOfEmployee = 32,
  IndustryClassification = 62,
  Location = 27,
  Status = 28,
}

export enum RemoveOneSourceFilter {
  Status = 28,
}

export enum FilingType {
  Both = 0,
  AnnualReport = 1,
  LocalRegistryFiling = 2,
}

export enum CharacterType {
  OpeningBracket = 0,
  ClosingBracket = 1,
  Space = 2,
  Quote = 3,
  Character = 4,
}

export enum ComponentType {
  OpeningBracket = 0,
  ClosingBracket = 1,
  Connector = 2,
  Word = 3,
  Phrase = 4,
}

export enum scrapingType {
  Contact = 1,
  MainPage = 2,
  AboutUs = 4,
  Products = 8,
  Service = 16,
}
export enum NotificationType {
  Report = 1,
}
